// extracted by mini-css-extract-plugin
export default {"content":"FhqDtscE","logo":"_3x4P7nN9","heading":"_136otO1m","text":"_1CDigGAN"};